angular.module('assets')
    .component('assetDocBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<?'
        },
        templateUrl: 'app/asset/document/btn-options.html',
        controller: function ($rootScope, AssetDocumentService, FilesSimpleUploadService, FilesLibrary, AssetSettingsLoader) {
            this.AssetDocumentService = AssetDocumentService;

            this.fileResourceName = 'ASSET-DOCUMENT'

            this.$onChanges = () => {
                AssetSettingsLoader.isSupervisor().then(result => this.isSupervisor = result);
                this.isSourceProjectMember = false;
                this.isDestinationProjectMember = false;

                if(this.item.sourceProject){
                    AssetSettingsLoader.isMemberOf(this.item.sourceProject.id).then(isProjectMember => this.isSourceProjectMember = isProjectMember)
                }
                if(this.item.destinationProject){
                    AssetSettingsLoader.isMemberOf(this.item.destinationProject.id).then(isProjectMember => this.isDestinationProjectMember = isProjectMember)
                }
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('asset-doc.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('asset-doc.updated'));
        }
    })
